import { render, staticRenderFns } from "./TableListProducts.vue?vue&type=template&id=3a6a72b2&"
import script from "./TableListProducts.vue?vue&type=script&lang=js&"
export * from "./TableListProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a6a72b2')) {
      api.createRecord('3a6a72b2', component.options)
    } else {
      api.reload('3a6a72b2', component.options)
    }
    module.hot.accept("./TableListProducts.vue?vue&type=template&id=3a6a72b2&", function () {
      api.rerender('3a6a72b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/products/TableListProducts.vue"
export default component.exports